<template>
  <div class="card shadow-lg rounded-3 py-3" style="border-radius:0; border:none">
    <div class="card-body p-1">
      <h1 class="card-title mb-3 text-dark text-uppercase" style="font-weight:700"><span
          style="color: #9ccc65">Log</span> In</h1>

      <form @submit.prevent="login">
        <div class="row">
          <div class="col">
            <div class="form-floating mb-3">
              <input type="text" class="form-control"
                     v-model="username" id="floatingTextInput1" placeholder="Username"
                     required>
              <label for="floatingTextInput1">Username</label>
            </div>
          </div>
        </div>
        <div class="form-floating mb-3">
          <input :type="passwordFieldType" class="form-control"
                 v-model="password" id="floatingPasswordInput"
                 placeholder="Password" required autocomplete="on">
          <label for="floatingPasswordInput">Password</label>
        </div>
        <label class="show-password-checkbox">
          <input type="checkbox" v-model="show_password">
          Show Password
        </label>

        <div class="text-center">
          <p class="text-danger">{{ warning }}</p>
          <button :disabled="loading" type="submit" class="btn">
            Login
            <span v-if="loading" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoginForm",
  async beforeMount() {
    let device = await Device.getDeviceId();
    localStorage.clear();
    localStorage.setItem('_capuid', device)
  },
  data() {
    return {
      setup: true,
      username: '',
      password: '',
      loading: false,
      warning: '',
      show_password : false,
    }
  },
  computed : {
    passwordFieldType(){
      return this.show_password?'text':'password';
    },
  },
  methods: {
    login() {
      this.loading = true;
      return this.$store.dispatch('appLogin', {
        email: this.username,
        password: this.password,
      }).then(() => this.$router.push({name: 'setup'}))
          .catch(err => this.warning = err)
          .finally(() => this.loading = false)
    },
    forgotPassword(){
      return this.$router.push({ name : 'forgot-password' });
    }
  }
}
</script>

<style scoped>
.btn {
  background: #1e88e5;
  color: white;
  font-weight: 600;
  display: block;
  width: 100%;
  height: 45px;
}

.card {
  padding-left: 10px;
  padding-right: 10px;
  width: 400px;
  max-width: 95vw;
  margin-top: -3rem !important;
}

.show-password-checkbox{
  margin-bottom: 20px;
}
</style>
